import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { RETENTION_STATUSES } from './constants'

const useStyles = makeStyles(() => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9999,
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
  neutral: {
    boxSizing: 'border-box',
    padding: '1px 7px',
    border: '1px solid #E5E7EB',
  },
}))

export default function RetentionStatusChip({ status, className, ...props }) {
  const classes = useStyles()
  const meta = RETENTION_STATUSES[status]
  if (!meta) return null

  return (
    <span
      className={className ? `${classes.chip} ${className}` : classes.chip}
      style={{ backgroundColor: meta.background, color: meta.color }}
      {...props}
    >
      {meta.label}
    </span>
  )
}

RetentionStatusChip.propTypes = {
  status: PropTypes.oneOf(Object.keys(RETENTION_STATUSES)).isRequired,
  className: PropTypes.string,
}

// Same chip shape as the status chips in the neutral (Inactive) colors with the
// filter chips' border, for labels that are not a status, like recipient names.
export function NeutralChip({ children, className, ...props }) {
  const classes = useStyles()
  const { background, color } = RETENTION_STATUSES.INACTIVE
  const classNames = [classes.chip, classes.neutral, className]
    .filter(Boolean)
    .join(' ')

  return (
    <span
      className={classNames}
      style={{ backgroundColor: background, color }}
      {...props}
    >
      {children}
    </span>
  )
}

NeutralChip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
